import { FormSelect } from '@systemeio/ui'
import { CourseId } from 'modules/courses/courses/types/course-interface'
import { DigitalResourcesTypeEnum } from 'modules/digital-product/enums/digital-resources-type-enum'
import { useDigitalResources } from 'modules/digital-product/resources/hooks/use-digital-resources'
import ItemSteps from 'modules/stores/store/components/item-steps'
import React, { FC } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

export interface AdvancedCourseProps {
  courseId?: CourseId
  courseSelectorError?: string
  onChangeCourse: (courseId?: number) => void
}

export const AdvancedCourse: FC<AdvancedCourseProps> = ({
  courseId,
  courseSelectorError,
  onChangeCourse,
}) => {
  const { t } = useLocoTranslation()

  const { coursesData } = useDigitalResources({
    resourceType: DigitalResourcesTypeEnum.membership_course,
  })

  return (
    <ItemSteps
      steps={[
        {
          key: 'course select',
          title: t('dashboard.store.item.e_course.select_course.title'),
          element: (
            <FormSelect
              placeholder={t('dashboard.store.item.e_course.select_course.placeholder')}
              value={courseId}
              data={coursesData}
              onChange={onChangeCourse}
              error={courseSelectorError}
              withoutCloseIcon
            />
          ),
        },
      ]}
    />
  )
}
